import { render, staticRenderFns } from "./AddressWrapper.vue?vue&type=template&id=3935ad53&scoped=true&"
import script from "./AddressWrapper.vue?vue&type=script&lang=js&"
export * from "./AddressWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3935ad53",
  null
  
)

export default component.exports